import { Component, Input } from "@angular/core";
import { IdCardDisplayStatus } from "../../../enums/capStatus.enum";

@Component({
  standalone: false,
  selector: "app-idcard-status-badge",
  templateUrl: "./idcard-status-badge.component.html"
})
export class IdCardStatusBadgeComponent {
  @Input() idCardFiles: any[] = [];
  @Input() idCardExpirationDate: string | null | undefined;
  @Input() variant: "date" | "card" | "all" = "all";

  readonly IdCardDisplayStatus = IdCardDisplayStatus;

  get status(): IdCardDisplayStatus {
    const hasFiles = (this.idCardFiles?.length ?? 0) > 0;
    if (!hasFiles) return IdCardDisplayStatus.MISSING_CARD;

    if (!this.idCardExpirationDate) return IdCardDisplayStatus.MISSING_DATE;

    const expDate = new Date(this.idCardExpirationDate);
    if (isNaN(expDate.getTime())) return IdCardDisplayStatus.MISSING_DATE;
    expDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (expDate < today) return IdCardDisplayStatus.EXPIRED;

    const twoWeeks = new Date(today);
    twoWeeks.setDate(twoWeeks.getDate() + 14);
    if (expDate <= twoWeeks) return IdCardDisplayStatus.RENEWAL;

    return IdCardDisplayStatus.VALID;
  }
}
